module.exports = __webpack_public_path__ + "img/cap1.32203f56.jpg";